import { useIntl } from 'react-intl';

export function Percent({ percentNumber }: { percentNumber: number }) {
  const { formatNumber } = useIntl();
  return formatNumber(percentNumber, { maximumFractionDigits: 2, style: 'percent' });
}
